import { Component, Input } from "@angular/core";
import { ICustomerWalletCategory } from "../../interfaces/customer-wallet.interface";
import { Store } from "@ngrx/store";
import { AppState } from "@toro/common/shared/interfaces/app-state.interface";
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
    selector: 'customer-wallet-category-accordion',
    templateUrl: './category-accordion.component.html',
    providers: [],
    styleUrls: ['./category-accordion.component.scss'],
})
export class CustomerWalletCategoryAccordionComponent {

    constructor(
        private store: Store<AppState>,
    ){
    }

    @Input()
    public category: ICustomerWalletCategory;

    public elementClickItem(link: string, strategicClass: string) {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': 'Evolução da carteira',
            'Time Responsável': "Mezzo",
            'Element': 'Ver mais sobre estes Ativos',
            'Strategic Class': strategicClass,
        });

        setTimeout(() => {
            window.location.href = link;
        }, 100);
    }


    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }
}
